import { http } from '@pendo/http';
const reportsApi = '/api/s/_SID_/report';

// Endpoints should be called through VUEX ONLY to ensure the state store is
// up-to-date and that we only call the API when needed.
export function createScheduledReport (reportId, report) {
    return http.post(`${reportsApi}/${reportId}/scheduledreport`, report);
}

export function deleteScheduledReport (reportId, id) {
    return http.delete(`${reportsApi}/${reportId}/scheduledreport/${id}`);
}

export function fetchScheduledReport (reportId, id) {
    return http.get(`${reportsApi}/${reportId}/scheduledreport/${id}`);
}

export function fetchScheduledReports (reportId) {
    return http.get(`${reportsApi}/${reportId}/scheduledreport`);
}

export function fetchSubscriptionSummary (reportId) {
    return http.get(`${reportsApi}/${reportId}?subscriptionSummary=true`);
}

export function updateScheduledReport (reportId, report) {
    return http.put(`${reportsApi}/${reportId}/scheduledreport/${report.id}`, report);
}
